import CustomSwitch from "../../../../../../common/CustomSwitch";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {HStack, VStack} from "native-base";
import AppText from "../../../../../../common/AppText";
import {t} from "../../../../../../../services/i18n";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {isMobile} from "../../../../../../../services/Helpers";
import {updateScheduleSetting} from "../../../../../../../redux/ScheduleSlice";


const QuickViewDisplay = (props) => {
    const {values, setFieldValue} = props
    const box = useSelector((state) => state.box.box);
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const [isChecked, setIsChecked] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if(box) {
            console.log('box.show_schedule_preview', box.show_schedule_preview)
            setIsChecked(!!box.show_schedule_preview)
        }
    }, [box.show_schedule_preview]);

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    const toggle = (val) => {
        const value = val ? 1 : 0
        setFieldValue('showSchedulePreview', value)
        setIsChecked(val)
    }

    const save = () => {
        if(isMobile) {
            dispatch(updateScheduleSetting({show_schedule_preview: values.showSchedulePreview}))
        }
    }

    if(isChecked === null) return <></>
    return (
        <VStack space={'0.5rem'}>
            <HStack justifyContent={'space-between'} alignItems={'center'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('showSchedulePreview')}</AppText>
                <CustomSwitch isChecked={isChecked} onToggle={toggle}/>
            </HStack>
            <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('showSchedulePreviewTxt')}</AppText>
        </VStack>


    )
}

export default QuickViewDisplay